import { ShareUrlParamsType } from 'context';
import { chunk } from 'lodash';
import { CREATIVE_PARAMS_BANNER, CREATIVE_PARAMS_PLAYER_SIZE, CREATIVE_PARAMS_MOBILE_VIEW } from './constants';

type ParamGroup = Array<string>;
type ParamGroups = Array<ParamGroup>;

export type MappedParamGroupType = {
  [key: string]: ShareUrlParamsType;
};

export type SuccessErrorResponeType = {
  success: ParamGroups | null;
  error: boolean | null;
};

const decodeBase64 = (encodedString: string) => {
  try {
    return atob(decodeURIComponent(encodedString));
  } catch (e) {
    return null;
  }
};

const validateParams = (params: string, chunkLen: number) => {
  const arr = params.split(',');
  // if the array length is not at least the length of the chunk and or divisible by the chunk length, we dont have the right number of params and should invalidate
  if (arr.length < chunkLen || arr.length % chunkLen !== 0) {
    return null;
  }
  const chunks = chunk(arr, chunkLen);

  // checks if the incoming param vals are accepted sets the chunk as false if not
  const validateChunks: boolean[] = chunks.map(([idPos, displayPos, sizePos, mobilePos])=> {
    const id = parseInt(idPos, 10);
    const validId = !isNaN(id);
    const validDisplayOption = Object.keys(CREATIVE_PARAMS_BANNER).includes(displayPos);

    // return true on the following options as a default because they may not be presnet for gallery view
    const validSizeOption = sizePos !== '-1' && sizePos !== undefined? Object.keys(CREATIVE_PARAMS_PLAYER_SIZE).includes(sizePos) : true;
    const validMobileOption = mobilePos ? Object.keys(CREATIVE_PARAMS_MOBILE_VIEW).includes(mobilePos) : true;
    return !!(validId && validDisplayOption && validSizeOption && validMobileOption);
  });
  return validateChunks.includes(false) ? null : chunks;
};

export const getParamsObj = ([id, banner, size, mobile]: ParamGroup) => ({
    displayBanner: CREATIVE_PARAMS_BANNER[banner],
    playerSizeFormat: size || '2', // default to 2, md
    mobileView: CREATIVE_PARAMS_MOBILE_VIEW[mobile || 0], // default to 0, false
  });

export const mapGalleryParams = (result: ParamGroups) => result.reduce((acc, paramGroup) => {
  const id = paramGroup[0].toString();
  const buildParamsObj = getParamsObj(paramGroup);
  acc = {
    ...acc,
    [id]: {
      ...buildParamsObj,
    }
  };
  return acc;
}, {});

export const readParams = (encodedParams: string, view: string) => {
  const result = { error: null, success: null };
  const chunkLen = view === 'gallery' ? 2 : 4;
  const decodedParams = decodeBase64(encodedParams);

  if (!decodedParams) return { ...result, error: true };

  const validateParamsResult: ParamGroups | null = validateParams(decodedParams, chunkLen);

  if (!validateParamsResult) return { ...result, error: true };

  return { ...result, success: validateParamsResult };
};